import React, { Suspense } from 'react';
import BookingTimeSlotWrapper from './bookingTimeSlotWrapper'; 

const BookingTimeSlotWeekView = React.lazy(() => import('./bookingTimeSlot_weekView'));
const BookingTimeSlotMonthView = React.lazy(() => import('./bookingTimeSlot_monthView'));

const BookingTimeSlotContainer = (props) => { 
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <BookingTimeSlotWrapper {...props}>
                {props.viewType === "month" ? (
                    <BookingTimeSlotMonthView />
                ) : (
                        <BookingTimeSlotWeekView/>
                )}
            </BookingTimeSlotWrapper>
        </Suspense>
    );
};

export default BookingTimeSlotContainer;
